import PropTypes from 'prop-types';
import React from 'react';
import Typography from 'Components/UI/Typography';
import classNames from 'classnames';
import ActionItemCard
  from 'Components/ComponentLibrary/Organisms/MessageList/MessageListItem/MessageContent/Content/MessagesActionItemCard';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import {
  AttachmentsSectionRebranded,
} from 'Components/ComponentLibrary/Components/Uncategorized/AttachmentsSectionRebranded';
import RichTextDisplayWithMessageContextMenu
  from 'Components/UI/RichTextDisplayWithMessageContextMenu';


const useStyles = buildUseStyles('MeetingBody', (theme) => ({
  body: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  actionItemListContainer: {
    marginTop: theme.spacing(3),
  },
  toDoText: {
    padding: theme.spacing(2, 0),
  },
  card: {
    marginRight: theme.spacing(1),
  },
}));

const MeetingCommunicationBody = ({
  meetingAgenda,
  messageContent,
  incompleteClientActionItemResource,
  incompletePlannerActionItemResource,
  attachmentsCollection,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const showActionItems = incompleteClientActionItemResource?.length > 0 || incompletePlannerActionItemResource?.length > 0;

  return (
    <Box className={classes.body}>
      <RichTextDisplayWithMessageContextMenu
        content={messageContent || meetingAgenda.attr('content')}
      />
      {showActionItems ? (
        <Box className={classNames(classes.actionItemListContainer)}>
          {incompleteClientActionItemResource?.length > 0 && (
            <Box>
              <Typography
                className={classNames(classes.toDoText)}
                color={'primary'}
                variant={'h5'}
              >
                {'Your To-Dos For This Meeting'}
              </Typography>
              {incompleteClientActionItemResource.map(actionItem => (
                <ActionItemCard
                  className={classes.card}
                  key={actionItem.id()}
                  actionItem={actionItem}
                />
              ))}
            </Box>)}
          {incompletePlannerActionItemResource?.length > 0 && (
            <Box>
              <Typography
                className={classNames(classes.toDoText)}
                color={'primary'}
                variant={'h5'}
              >
                {"Facet's To-Dos For This Meeting"}
              </Typography>
              {incompletePlannerActionItemResource.map(actionItem => (
                <ActionItemCard
                  key={actionItem.id()}
                  actionItem={actionItem}
                />
              ))}
            </Box>
          )}
        </Box>
      ) : null}
      {attachmentsCollection
        ? <AttachmentsSectionRebranded
          attachmentsCollection={attachmentsCollection}
          eventCategory={'Messages'}
        />
        : null}
    </Box>
  );
};

MeetingCommunicationBody.defaultProps = {
  messageContent: '',
};

MeetingCommunicationBody.propTypes = {
  meetingAgenda: PropTypes.instanceOf(fr.Resource).isRequired,
  messageContent: PropTypes.string,
  incompleteClientActionItemResource: PropTypes.object.isRequired,
  incompletePlannerActionItemResource: PropTypes.object.isRequired,
  attachmentsCollection: PropTypes.object.isRequired,
};


export default MeetingCommunicationBody;
